import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'organizations', redirectTo: 'organizations/list', pathMatch: 'full' },
  {
    path: 'organizations',
    children: [
      {
        path: 'list',
        loadComponent: () =>
          import('./list/organizations.component').then((m) => m.OrganizationsComponent),
      }
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class organizationsRoutingModule {
  static routes = admin;
}
